import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SalesService } from "../../sales.service";
import notify from "devextreme/ui/notify";
import { NumericTextBoxComponent } from "@progress/kendo-angular-inputs";

@Component({
  selector: "app-order-transfer",
  templateUrl: "./order.transfer.component.html",
  styleUrls: ["./order.transfer.component.scss"],
})
export class OrderTransferComponent implements OnInit {
  orderTransferForm: FormGroup;
  loadingIndicator: boolean;
  allCompanyBranches: any[];
  companyBranchLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  responseMsg: string;
  saleOrderTimeOut: any;
  salesOrderData: any;
  @ViewChild("salesOrderVar") salesOrderVar: NumericTextBoxComponent;
  
  constructor(
    private _salesService: SalesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderTransferComponent>
  ) {
    
    console.log("edited data", data);
  }

  ngOnInit() {
    this.allCompanyBranches = [];
    this.orderTransferForm = new FormGroup({
      salesOrderTransferId: new FormControl(0, []),
        salesOrderId: new FormControl(null, [Validators.required]),
        fromCompanyBranchId: new FormControl(null,
          [Validators.required]
        ),
        toCompanyBranchId: new FormControl(null, [Validators.required]),

        addDateTime: new FormControl(new Date(), []),
        userId: new FormControl(
          JSON.parse(localStorage.getItem("userData")).userId,
          []
        ),
        addUserId: new FormControl(
          JSON.parse(localStorage.getItem("userData")).userId,
          []
        ),
        updateDateTime: new FormControl(new Date(), []),
        updateUserId: new FormControl(
          JSON.parse(localStorage.getItem("userData")).userId,
          []
        ),
        active: new FormControl(true, [])
      });
    this.getAllCompanyBranchesWithOutIsplant();
    setTimeout(() => {
      this.salesOrderVar.blur();
      this.salesOrderVar.focus(); 
    }, 50);
    
  }

  onChange(event) {
    clearTimeout(this.saleOrderTimeOut);
    this.saleOrderTimeOut = setTimeout(() => {
        this.getAllSalesOrderBySalesOrderId(event);
    }, 1000);
  }

  /**
   * @name getAllSalesOrderBySalesOrderId
   * @returns array of object
   * @description sales order request data by id
   */
   getAllSalesOrderBySalesOrderId(saleOrderId: number) {
    this.loadingIndicator = true;
    this._salesService
      .getAllSalesOrderBySalesOrderId(saleOrderId)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload) {
            console.log("getAllSalesOrderById", response.data.payload);
            this.salesOrderData = response.data.payload;
            this.orderTransferForm.get('fromCompanyBranchId').setValue(this.salesOrderData.createdByBranchId);
          }
        } else {
          const option = {
            width: 300,
            displayTime: 5000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.log("err ", err);
      });
  }

  /**
   * @name getAllCompanyBranchesWithOutIsplant
   * @returns Promise
   * @description fetch all item
   */
   getAllCompanyBranchesWithOutIsplant() {
    this.companyBranchLoading = true;
    this._salesService
      .getAllCompanyBranchesWithOutIsplant()
      .then((response) => {
        if (response.data.completed) {
          this.allCompanyBranches = response.data.payload;
          this.orderTransferForm.get('toCompanyBranchId').setValue(response.data.payload[0].companyBranchId);
          this.companyBranchLoading = false;
        }
      })
      .catch((err) => {
        this.companyBranchLoading = false;
        console.error("Error:  ", err);
      });
  }
  /**
   * @name selectCompanyBranch
   * @retrun validation
   * @description check company branch same or not
   */

  selectCompanyBranch() {
      if (this.orderTransferForm.get('fromCompanyBranchId').value  == this.orderTransferForm.get('toCompanyBranchId').value) {
        this.orderTransferForm.get('toCompanyBranchId').setErrors({isValid: true});
        // this.orderTransferForm.get('toCompanyBranchId').setValidators([Validators.required]);
        // this.orderTransferForm.get('toCompanyBranchId').updateValueAndValidity;
      } else {
        this.orderTransferForm.get('toCompanyBranchId').setErrors(null);
        this.orderTransferForm.get('toCompanyBranchId').setValidators([Validators.required]);
        this.orderTransferForm.get('toCompanyBranchId').updateValueAndValidity();
      }
  }

  /**
   * @name generateStockOrderTransferReport
   * @returns void
   * @description Generate Report
   */
   generateStockOrderTransferReport(saleOrderId: number) {
    this._salesService
      .generateStockOrderTransferReport(saleOrderId)
      .then((res: any) => {
        console.log("Report Successfully Generate");
      })
      .catch((error) => {
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }
  /**
   * @name submitData
   * @return void
   * @param form 
   */
  submitData(form: FormGroup) {
    if (form.invalid) {
        Object.keys(this.orderTransferForm.controls).forEach((key) => {
          this.orderTransferForm.get(key).markAsTouched();
        });
        return false;
      }
    this.loadingIndicator = true;
    console.log('form', form.value)
    this._salesService
      .AddSalesOrderTransfer(form.value)
      .then((response: any) => {
        if (response.data.completed) {
          this.loadingIndicator = false;
          this.isSuccess = true;
          this.isError = false;
          this.responseMsg = response.data.message;
          // GENERATE REPORT FUNCTION
          this.generateStockOrderTransferReport(this.orderTransferForm.get('salesOrderId').value);
          // END
          this.dialogRef.close('close');
          this.orderTransferForm.get('salesOrderId').setValue(null);
          this.orderTransferForm.get('fromCompanyBranchId').setValue(null);
          // this.orderTransferForm.get('toCompanyBranchId').setValue(null);
          this.orderTransferForm.get('toCompanyBranchId').setValue(response.data.payload[0].companyBranchId);
          this.salesOrderVar.blur();
          this.salesOrderVar.focus();
         
          // setTimeout(() => {
          //   this.isSuccess = false;
          //   this.isError = false;
          // }, 800);
        } else {
          this.loadingIndicator = false;
          this.isSuccess = false;
          this.isError = true;
          this.responseMsg = response.data.message;
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        this.responseMsg = error.message;
      });
  }
}
